/**
 * File Name          : environment.development.ts
 * Author             : Auto-generated
 * Version            : 0.0.14
 * Date               : 2026-03-18
 * Description        : Development environment configuration (App Insights disabled)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const environment = {
  production: false,
  appInsights: {
    connectionString: '' // Disabled for local development
  },
  firmwareService: {
    // Feature flag: when true, fetch firmware from the artifact file service
    // (dev channel manifest) instead of the bundled fw-images/*.bin asset.
    // Falls back to bundled asset on fetch failure.
    // Dev environment defaults to true so local `ng serve` exercises the
    // new code path end-to-end.
    enabled: true,
    baseUrl: 'https://artifacts.rwthrive.com',
    channel: 'dev'
  }
};
